// import Image from "next/image";
import SVG from "react-inlinesvg";

import { useEffect, useState } from "react";
import { getDataFromSSR } from "@/handlers/client/commonClient";
import { parseMatchData } from "@/utils/ipl";
import { logger } from "@/utils/logging/log-util";
import { useRouter } from "next/router";
import AdSlot300x250 from "../Ads/AdSlot300x250";
import AdSlot728x90 from "../Ads/AdSlot728x90";

const SeriesList = ({ matchData = null, scrolled = false }) => {
  const router = useRouter();
  const currentPath = router?.asPath;
  const isTestSeries = currentPath.includes("/india-tour-of-england-2025");
  const [matchList, setMatchList] = useState(matchData);

  const getDefaultTab = () => {
    switch (matchData[0]?.status) {
      case "LIVE":
        return 1;
      case "RECENT":
        return 3;
      case "UPCOMING":
        return 2;
      default:
        return 3;
    }
  };
  const [currentTab, setCurrentTab] = useState(getDefaultTab());

  const dateFilterMatches =
    matchList &&
    matchList?.reduce((group, match) => {
      const { match_date_alt } = match;
      if (match_date_alt != "Invalid Date") {
        if (!group[match_date_alt]) {
          group[match_date_alt] = [];
        }
        group[match_date_alt].push(match);
        return group;
      } else {
        const dt = new Date().toLocaleDateString("en-US", {
          day: "2-digit",
          weekday: "short",
          month: "short",
        });
        if (!group[dt]) {
          group[dt] = [];
        }
        group[dt].push(match);
        return group;
      }
    }, {});

  const filteredMatchData =
    currentTab == 2
      ? Object.entries(dateFilterMatches || []).reverse()
      : currentTab == 3 ? Object.entries(dateFilterMatches || []) : Object.entries(dateFilterMatches || []).reverse();

  useEffect(() => {
    let matches = matchData;
    if (currentTab == 1) {
      matches = matchData.filter((match) => match.status == "LIVE");
    }
    if (currentTab == 2) {
      matches = matchData.filter((match) => match.status == "UPCOMING");
    }
    if (currentTab == 3) {
      matches = matchData.filter((match) => match.status == "ENDED");
    }
    setMatchList(matches);
  }, [currentTab]);

  useEffect(() => {
    const testSeriesId = 8159;
    const asiacupId = 13274; //13274 asiacup
    if (matchData && matchData[0]?.status == "LIVE") {
      async function getMatches() {
        try {
          const timeStamp = Date.now();
          // const matches = await getDataFromSSR(
          //   `/api/getLiveMatches?seriesId=${isTestSeries ? testSeriesId : asiacupId
          //   }&time=${timeStamp}`
          // );
          const matches = null; //disable getLiveMatches
          setMatchList((prevMatches) => {
            const updated = [...prevMatches];
            if(matches){
              for (const rawMatch of matches?.data.data) {
                const matchStats = parseMatchData(rawMatch);
                const idx = updated.findIndex((m) => m.id === rawMatch.match_Id);

                if (idx > -1) {
                  updated[idx] = matchStats; // update existing
                } else {
                  updated.unshift(matchStats); // prepend new
                }
              }
            }
            return updated;
          });
        } catch (err) {
          logger.error(err);
        }
      }

      getMatches();
      const interval = setInterval(() => {
        getMatches();
      }, 10000);

      return () => clearInterval(interval);
    }
  }, []);

  return (
    <div>
      <section className="py-2">
        {/* navbar  */}
        <div className="w-full flex items-center justify-start p-2">
          <div
            className={`w-[35%] text-center text-md  ${currentTab == 1
              ? "border-b-2 border-primary text-primary"
              : "text-[#00000099] border-b border-gray-200"
              }`}
          >
            <span
              className="cursor-pointer"
              onClick={() => {
                setCurrentTab(1);
              }}
            >
              Live
            </span>
          </div>
          <div
            className={`w-[35%] text-center text-md  ${currentTab == 2
              ? "border-b-2 border-primary text-primary"
              : "text-[#00000099] border-b border-gray-200"
              }`}
          >
            <span
              className="cursor-pointer"
              onClick={() => {
                setCurrentTab(2);
              }}
            >
              Upcoming
            </span>
          </div>
          <div
            className={`w-[35%] text-center text-md  ${currentTab == 3
              ? "border-b-2 border-primary text-primary"
              : "text-[#00000099] border-b border-gray-200"
              }`}
          >
            <span
              className="cursor-pointer"
              onClick={() => {
                setCurrentTab(3);
              }}
            >
              Recent
            </span>
          </div>
        </div>
        {!filteredMatchData?.length && (
          <div className="w-full flex flex-col justify-center items-center mt-12 mb-16 py-4 text-gray-500">
            <SVG
              src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/NoMatchData.svg"
              className="w-22 h-22 rounded-full mb-4"
            />
            No Matches Found
          </div>
        )}

        {filteredMatchData?.length > 0 &&
          filteredMatchData?.map(([matchDate, matches], idx) => {
            return (
              <div key={matchDate} className="w-full">
                <h2 className="bg-[#CDCDCD] w-fit p-2 rounded-full my-4 text-sm mx-auto">
                  {matchDate}
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-2">
                  {matches
                    ?.sort((a, b) => a.match_date.localeCompare(b.match_date))
                    ?.filter((item) => item?.match_date != "Invalid Date")
                    ?.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="min-w-full md:min-w-[50%] bg-white rounded-lg border border-gray-300 py-2"
                        >
                          <a
                            href={
                              item?.teamA_name == "tbc"
                                ? ""
                                : item?.url || "/sports/india-tour"
                            }
                            onClick={(e) => {
                              if (
                                item?.teamA_name == "tbc" ||
                                item?.url == "/sports/asia-cup-2025//info"
                              ) {
                                e.preventDefault(); // stops navigation
                              }
                            }}
                            className={`${item?.url === "/sports/asia-cup-2025//info"
                              ? "pointer-events-none  "
                              : ""
                              }`}
                          >
                            <div className="w-full px-2 border-b border-gray-400 flex items-center justify-between">
                              <span className="text-[#000000CC] flex items-center gap-1 text-xs mb-1">
                                <span className="">
                                  {isTestSeries
                                    ? "India Tour Of England"
                                    : "Asia Cup 2025"}
                                </span>
                                <span className="w-1 h-1 bg-gray-400 rounded-full"></span>
                                {item?.match_no}
                              </span>
                              <span className="flex items-center gap-1 text-sm mb-1">
                                {item.status}
                                {item?.status == "LIVE" && (
                                  <img
                                    height={24}
                                    width={24}
                                    src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/liveGif.gif"
                                    alt="live icon"
                                  />
                                )}
                              </span>
                            </div>
                            <div className="p-2">
                              <span className="flex items-center gap-2 mb-2">
                                <img
                                  width={24}
                                  height={24}
                                  src={
                                    item.teamA_name != "tbc"
                                      ? item.altLogoA || item.teama_logo
                                      : item.teama_logo
                                  }
                                  alt="teamA logo"
                                // className="rounded-full"
                                />
                                <span className="flex items-cetner gap-1 text-xs font-[600]">
                                  {item?.teamA_name?.toUpperCase()}
                                  {item?.winning_team == "A" && (
                                    <img
                                      src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/trophy.gif"}
                                      width={20}
                                      height={20}
                                      alt="trophy gif"
                                      className="-mt-1"
                                    />
                                  )}
                                </span>
                                {item?.status == "UPCOMING" ? (
                                  <span className={`text-sm ml-auto `}>
                                    {item.match_date}
                                  </span>
                                ) : (
                                  <span
                                    className={`text-sm ml-auto ${item?.batting_team == "A" ||
                                      item?.winning_team == "A"
                                      ? "font-semibold"
                                      : "mr-1"
                                      }`}
                                  >
                                    {item.teamA_score || "Yet to bat"}{" "}
                                    {item.teamA_overs
                                      ? "(" + item.teamA_overs + ")"
                                      : ""}
                                    {item?.batting_team == "A" && (
                                      <span className="text-primary text-md font-semibold">
                                        *
                                      </span>
                                    )}
                                  </span>
                                )}
                              </span>
                              <span className="flex items-center gap-2 mb-1">
                                <img
                                  width={24}
                                  height={24}
                                  src={
                                    item.teamB_name != "tbc"
                                      ? item.altLogoB || item.teamb_logo
                                      : item.teamb_logo
                                  }
                                  alt="teamA logo"
                                // className="rounded-full"
                                />
                                <span className="flex items-center gap-1 text-xs font-[600]">
                                  {item?.teamB_name?.toUpperCase()}
                                  {item?.winning_team == "B" && (
                                    <img
                                      src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/trophy.gif"}
                                      width={20}
                                      height={20}
                                      alt="trophy gif"
                                      className="-mt-1"
                                    />
                                  )}
                                </span>
                                {item?.status == "UPCOMING" ? (
                                  <span className={`text-sm ml-auto `}>
                                    {item?.match_time_gmt || item.match_time}
                                  </span>
                                ) : (
                                  <span
                                    className={`text-sm ml-auto ${item?.batting_team == "B" ||
                                      item?.winning_team == "B"
                                      ? "font-semibold"
                                      : "mr-1"
                                      }`}
                                  >
                                    {item.teamB_score || "Yet to bat"}{" "}
                                    {item.teamB_overs
                                      ? "(" + item.teamB_overs + ")"
                                      : ""}
                                    {item?.batting_team == "B" && (
                                      <span className="text-primary text-md font-semibold">
                                        *
                                      </span>
                                    )}
                                  </span>
                                )}
                              </span>
                            </div>
                            <div className="bg-gray-200 w-full p-2 text-center text-xs font-semibold">
                              <span>{item?.equation}</span>
                            </div>
                          </a>
                        </div>
                      );
                    })}
                </div>
              </div>
            );
          })}
      </section>
      {scrolled && (
        <div className="mx-4">
          <AdSlot300x250
            divId="div-gpt-ad-1659434604998-0"
            minWidth="300px"
            minHeight="250px"
          />
        </div>
      )}

      {scrolled && (
        <AdSlot728x90
          divId="div-gpt-ad-1707804176041-2"
          minWidth="728px"
          minHeight="90px"
        />
      )}
    </div>
  );
};

export default SeriesList;
